import "./About.module.css";
import Header from "@/reusable_sections/Header";
import FounderPortraitIntroduction from "./sections/FounderPortraitIntroduction";
import TheBoutiqueDifference from "./sections/TheBoutiqueDifference";
import WhyChooseUs from "./sections/WhyChooseUs";
import DiscoverHiddenGemsGallery from "./sections/DiscoverHiddenGemsGallery";
import Footer from "@/reusable_sections/Footer";
import SignatureJourneys from "./sections/SignatureJourneys";
export default function AboutPage() {
  return <div>
      <Header />
      <FounderPortraitIntroduction />
      <TheBoutiqueDifference />
      <SignatureJourneys />
      <WhyChooseUs />
      <DiscoverHiddenGemsGallery />
      <Footer />
    </div>;
}